const configBoxes = {
  details: [
    {
      label: "Estado:",
      value: "subscriptionStatusDesc",
      type: "string",
    },
    {
      label: "Fecha estado:",
      value: "lastStatusChangeDate",
      type: "date",
    },
    {
      label: "Operador:",
      value: "eventActionUser",
      type: "string",
    },
  ],
  suborganizations: {
    leftData: [
      {
        label: null,
        value: "firmSuborganizationName",
        type: "title",
      },
      {
        label: null,
        value: "firmSuborganizationCuit",
        type: "title",
      },
    ],
    rightData: [
      {
        label: "Cliente",
        value: null,
        type: "title",
      },
      {
        label: "Nombre:",
        value: "customerSuborganizationLegalName",
        type: "string",
      },
      {
        label: "CUIT:",
        value: "customerSuborganizationCuit",
        type: "string",
      },
      {
        label: "Estado:",
        value: "isServiceEnabled",
        type: "boolean",
      },
      {
        label: "Usuario creador:",
        value: "creationUser",
        date: 'creationDate',
        type: "user-date",
      },
      {
        label: "Usuario modificador:",
        value: "modificationUser",
        date: 'modificationDate',
        type: "user-date",
      }
    ],
  },
  instances: [
    {
      label: "Código de aplicación:",
      value: "appCode",
      type: "string",
    },
    {
      label: "Estado de acceso a la aplicación:",
      value: "orgAppAccessStatusCode",
      type: "string",
    },
    {
      label: "Version base de Mi Estudio:",
      value: "baseApplicationInstance",
      type: "boolean",
    },
    {
      label: "Colaboradores activos:",
      value: "activeAppUserCount",
      type: "string",
    },
    {
      label: "Usuarios de cliente activos (Invitados):",
      value: "activeExternalAppUserCount",
      type: "string",
    },
    {
      label: "Habilitación desde:",
      value: "accessStartDate",
      type: "date",
    },
    {
      label: "Habilitación hasta:",
      value: "accessFinishDate",
      type: "date",
    },
    {
      label: "ID de instancia aplicación:",
      value: "applicationInstanceId",
      type: "string",
    },
  ],
}

export default configBoxes
